import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import {
	IPropsGetManualReservationPriceQuote,
	IResponseGetManualReservationPriceQuote,
} from "./types"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"
import { ManualReservationAPI } from "../../../utils/constants"

async function getManualReservationPriceQuote(
	{ totalPrice, isDirectPaymentAccepted }: IPropsGetManualReservationPriceQuote,
	apiPrivate: AxiosInstance
) {
	const response: AxiosResponse<IResponseGetManualReservationPriceQuote> =
		await apiPrivate.get(`${ManualReservationAPI}/PriceQuote`, {
			params: { totalPrice, isDirectPaymentAccepted },
		})
	return response.data
}

export function useGetManualReservationPriceQuote(
	data: IPropsGetManualReservationPriceQuote,
	options?: Omit<
		UseQueryOptions<IResponseGetManualReservationPriceQuote>,
		"queryKey" | "queryFn"
	>
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [
			APIS_KEYS.GETMANUALRESERVATIONPRICEQUOTE,
			data.totalPrice,
			data.isDirectPaymentAccepted,
		],
		queryFn: () => getManualReservationPriceQuote(data, apiPrivate),
		...options,
	})
}
